import { useMutation, gql } from '@apollo/client'

const useDeleteProcessMultipleInvoicesLater = () => {
  const [deleteProcessInvoicesLater, { loading, error }] = useMutation(
    gql`
      mutation ($invoiceIds: [String!]!) {
        deleteProcessInvoicesLater (invoiceIds: $invoiceIds) {
          total
          success
          failed
        }
      }
    `
  )
  return [deleteProcessInvoicesLater, { loading, error }]
}

export default useDeleteProcessMultipleInvoicesLater
